module.exports = __webpack_public_path__ + "img/80.2.TN.baba3956.png";